import React, { useState, useEffect } from 'react'

import { Button, makeStyles, Paper } from '@material-ui/core'

import MainContainer from '../../components/MainContainer'
import MainHeader from '../../components/MainHeader'
import MainHeaderButtonsWrapper from '../../components/MainHeaderButtonsWrapper'
import ProtectedRoute from '../../components/ProtectedRoute'
import Title from '../../components/Title'
import WizardDialog from '../../components/WizardDialog/index.js'

const useStyles = makeStyles(theme => ({
  mainPaper: {
    width: '100%',
    minHeight: '200px',
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  Texth3: {
    paddingLeft: 10
  },
  BtnIni: {
    MarginLeft: 10,
    backgroundColor: '#666'
  }
}))
const Wizard = () => {
  const classes = useStyles()

  useEffect(() => { }, [])
  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const [modalOpen, setModalOpen] = useState(false)
  const handleOpenToAdd = () => {
    setModalOpen(true)
  }

  return (
    <ProtectedRoute requiredRoles={['super', 'admin']} fallbackPath="/tickets">
      <MainContainer>
        <MainHeader>
          <Title>Wizard</Title>
          <MainHeaderButtonsWrapper>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenToAdd}
            >
              Iniciar
            </Button>
          </MainHeaderButtonsWrapper>
        </MainHeader>
        <Paper className={classes.mainPaper} variant="outlined">
          <h3 className={classes.Texth3}>
            Ajuda na criação das conexões, usuários e departamentos
          </h3>

          <WizardDialog modalOpen={modalOpen} onClose={handleCloseModal} />
        </Paper>
      </MainContainer>
    </ProtectedRoute>
  )
}

export default Wizard
